export var STATIC_ASSETS_CDN_URL = "https://static.nib.com.au";
export var FONTS_CDN_URL = "".concat(STATIC_ASSETS_CDN_URL, "/fonts");